<template>
  <v-row
    align="center"
    justify="center"
  >
    <v-col>
      <div class="profile">
        <v-row dense>
          <v-col
            cols="12"
          >
            <v-card class="skills"
              :color="skill_card.color"
              dark
            >
              <div class="d-flex flex-no-wrap justify-space-between">
                <v-row justify="center">
                  <v-col cols="12">
                    <v-card-title class="headline"
                      min-width="250px"
                      v-text="skill_card.title"
                    ></v-card-title>
                    <v-card-subtitle
                      v-text="skill_card.subtitle"
                    >
                    </v-card-subtitle>
                  </v-col>
                  <v-col
                    v-for="(skill, i) in skills"
                    :key="i"
                    cols="auto"
                  >
                    <Skill 
                      :language="skill.language"
                      :subskills="skill.subskills"
                      :fav="skill.fav"
                      :period="skill.period"
                      :comment="skill.comment"
                      :icon="skill.icon"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Skill from '@/components/Skill.vue'
import skill_json from '@/assets/skills/skill.json'

export default {
  components: {
    Skill
  },

  data: function() {
    return {
      skill_card: {
        title: 'スキル',
        subtitle: '経験してきた言語・フレームワークの一覧です。',
        color: 'grey darken-3',
      },
      skills: skill_json
    }
  }
}
</script>
